import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import { StyledButton } from "@/components";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const Filter = ({
  initialValues = {},
  filterOptions = {},
  onChange = () => {},
}) => {
  const [date, setDate] = useState();

  const handleDatePickerChange = (newDate, setFieldValue) => {
    setDate(newDate);
    setFieldValue("MonthYear", newDate); // Update Formik field
    onChange("MonthYear", newDate); // Trigger external onChange
  };

  return (
    <Formik initialValues={initialValues}>
      {({ resetForm, setFieldValue }) => (
        <Form>
          <Grid container alignItems="center" spacing={2}>
            {/* Dynamic Select Fields */}
            {Object.keys(filterOptions).map((filterKey, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                {/* Render Select or Date Picker based on key */}
                {filterKey === "MonthYear" ? (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month"]}
                      value={date}
                      components={{ OpenPickerIcon: CalendarMonthIcon }}
                      onChange={(newDate) =>
                        handleDatePickerChange(newDate, setFieldValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Select Month"
                          fullWidth
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "8px",
                              height: "100%",
                              boxSizing: "border-box",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "8px",
                              borderWidth: "1px",
                            },
                          }}
                        />
                      )}
                      slotProps={{
                        textField: {
                          placeholder: "Select Month", // Ensure placeholder is shown when empty
                        },
                      }}
                    />
                  </LocalizationProvider>
                ) : (
                  <FormikSelectInput
                    name={filterKey}
                    label={
                      filterKey === "state"
                        ? "State"
                        : filterKey === "location"
                        ? "Location"
                        : ""
                    }
                    search={true}
                    options={filterOptions[filterKey]}
                    placeholder={`Select ${
                      filterKey === "state"
                        ? "State"
                        : filterKey === "location"
                        ? "Location"
                        : ""
                    }`}
                    width="100%"
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue(filterKey, value);
                      console.log(filterKey, value);

                      onChange(filterKey, value);
                    }}
                  />
                )}
              </Grid>
            ))}

            {/* Button Section */}
            <Grid
              item
              xs={12}
              sm={6}
              container
              justifyContent="flex-end"
              marginTop={3}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "end",
                }}
              >
                <StyledButton
                  sx={{
                    p: (theme) => theme.spacing(1, 2),
                    m: (theme) => theme.spacing(0, 1),
                    borderRadius: (theme) => theme.shape.s,
                    height: 40,
                  }}
                  type="reset"
                  label="Reset"
                  variant="outlined"
                  size="medium"
                  onClick={() => {
                    resetForm();
                    setDate(null);
                    onChange("state", "");
                    onChange("location", "");
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default Filter;
